import styled, { css } from 'styled-components';
import { breakpoints, colors, cssprops, getTypography, pxToRem } from '@vfit/shared/themes';
import { ISlotsCalendarInputForStyled } from './slotsCalendarInput.models';

const scrollbar = css`
  &::-webkit-scrollbar {
    width: ${pxToRem(4)};
    height: ${pxToRem(18)};
    border-radius: ${pxToRem(20)};
  }

  &::-webkit-scrollbar-thumb {
    background: ${colors.$bebebe};
    border-radius: ${pxToRem(20)};
  }

  &::-webkit-scrollbar-track {
    background: ${colors.$transparent};
  }
`;

export const Wrapper = styled.div<ISlotsCalendarInputForStyled>`
  width: 100%;
  ${cssprops.styled};

  label h4 {
    pointer-events: none;
  }
`;

export const SlotsGroups = styled.div`
  display: flex;
  flex-direction: column;
  row-gap: ${pxToRem(24)};
`;

export const Group = styled.div<ISlotsCalendarInputForStyled>`
  ${scrollbar}

  @media (min-width: ${breakpoints.tablet}) {
    ${({ slotsGroupsMaxHeight }) =>
      slotsGroupsMaxHeight !== undefined
        ? `max-height: ${pxToRem(slotsGroupsMaxHeight > 0 ? slotsGroupsMaxHeight : 0)};`
        : ''}
    overflow-y: auto;
  }
`;

export const Day = styled.h4`
  ${getTypography('body1.regular')}
  margin: 0;

  strong {
    ${getTypography('h6.extrabold')}
  }

  @media (min-width: ${breakpoints.tablet}) {
    text-align: center;
  }
`;

export const Slots = styled.div<ISlotsCalendarInputForStyled>`
  ${scrollbar}
  display: flex;
  flex-direction: column;
  margin-top: ${pxToRem(12)};
  row-gap: ${pxToRem(8)};
  padding: 1px;

  @media (min-width: ${breakpoints.tablet}) {
    ${({ slotsGroupsMaxHeight }) =>
      slotsGroupsMaxHeight !== undefined
        ? `max-height: ${pxToRem(slotsGroupsMaxHeight > 64 ? slotsGroupsMaxHeight - 64 : 0)};`
        : ''}
    overflow-y: auto;
  }

  @media (min-width: ${breakpoints.desktop}) {
    ${({ slotsGroupsMaxHeight }) =>
      slotsGroupsMaxHeight !== undefined
        ? `max-height: ${pxToRem(slotsGroupsMaxHeight > 68 ? slotsGroupsMaxHeight - 68 : 0)};`
        : ''}
  }
`;

